import { tv } from 'tailwind-variants'

export const cardFrameVariants = tv({
  base: 'p-1 rounded-xl',
  variants: {
    accentColor: {
      none: 'border border-white/20',
      yellow: 'shadow-yellow-top-accent',
      green: 'shadow-green-top-accent',
      blue: 'shadow-blue-top-accent',
      pink: 'shadow-pink-top-accent'
    }
  },
  defaultVariants: {
    accentColor: 'none'
  }
})
